import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuestionsComponent } from './questions.component';
import { QuestionsViewComponent } from './questions-view/questions-view.component';

const routes: Routes = [
    {
        path: '',
        component: QuestionsComponent,
        children: [
            {
                path: '',
                canActivateChild: [],
                children: [
                    { path: 'list', component: QuestionsViewComponent },
                    { path: 'view/:categoryId', component: QuestionsViewComponent },
                    { path: 'view/:categoryId/:questionId', component: QuestionsViewComponent },
                    { path: 'view/:categoryId/:questionId/:isArchived', component: QuestionsViewComponent },
                    { path: 'view', component: QuestionsViewComponent },
                    { path: ':categoryId', component: QuestionsViewComponent },
                    { path: '', component: QuestionsViewComponent }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})
export class QuestionsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/questions/questions-routing.module.ts